import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FlipCards from "./FlipCards";

export default function RentItems() {
  return (
    <>
      <Navbar />

 
      <section id="home" className="relative w-full min-h-screen overflow-hidden -mt-36">
        {/* Background Image */}
        <div className="absolute inset-0 bg-white z-0" />


        {/* Foreground content with black transparent background */}
        <div className="relative z-10">
          <div id="flip-cards">
            <FlipCards />
          </div>
        </div>
      </section>


      <Footer />
    </>
  );
}
